import React from 'react';
import {useDispatch} from "react-redux";
import {SET_OTHER_BANK} from "../../store/actionTypes/calculatorActionTypes";
import {assetsBaseUrl} from "../../services/calculationsApi";
import {FormattedMessage} from "react-intl";
import {numberToCurrency} from "../../services/helpers";

function BankCard({isMain, bankData, grossMonthlyCost, selector, selected}) {
  const dispatch = useDispatch();
  const toggleBank = (item, action) => {
    dispatch({
      type: SET_OTHER_BANK,
      action: action,
      bank: item
    })
  }


  return (
        <div className={`ct-step__summary-bank-card ${isMain ? 'ct-step__summary-bank-card-main' : ''} ${!selector ? 'ct-step__summary-bank-card--fixed-width' : ''}` }>
            <div>
                <img src={`https://www.hypotheker.nl/assets/images/logos_hypotheekaanbieders/${bankData.logoUrl}`} alt=""/>
            </div>

            <div className="ct-step__summary-bank-card-fields">
                {isMain ? (
                    <>
                        <div>
                            <div>
                              <FormattedMessage id={'allBanksModal.overviewModal.bankCard.mortgageType'} defaultMessage={'Hypotheekvorm'} />
                            </div>

                            <div>
                                {bankData.hypotheekVorm === 'Annuïteitenhypotheek' || bankData.hypotheekVorm === 'Annuiteitenhypotheek'? 'Annuïteiten' : 'Lineair'}
                            </div>
                        </div>

                        <div>
                            <div>
                              <FormattedMessage id={'allBanksModal.overviewModal.bankCard.interestPeriod'} defaultMessage={'Rentevaste periode'} />
                            </div>

                            <div>
                                {bankData.rentevastePeriode} Jaar
                            </div>
                        </div>
                    </>
                ) : null}

                <div>
                    <div>
                      <FormattedMessage id={'allBanksModal.overviewModal.bankCard.interestRate'} defaultMessage={'Rentepercentage'} />
                    </div>

                    <div>
                        {bankData.rentestand?.toFixed(2)}%
                    </div>
                </div>
                {grossMonthlyCost &&
                <div>
                    <div>
                      <FormattedMessage id={'allBanksModal.overviewModal.bankCard.monthly'} defaultMessage={'Per maand'} />
                    </div>

                    <div className="ct-step__summary-bank-card-fields-monthly">
                        {numberToCurrency(grossMonthlyCost)}
                    </div>
                </div>
                }
            </div>
            {selector &&
            <div  className={'ct-step__summary-bank-card__selector'}>
              {selected &&
              <button  onClick={() => toggleBank(bankData, "remove")} className="ct__button ct__button__summary ct__button__summary--grey ct__button-icon">
                <img src={`${assetsBaseUrl}/assets/svg/remove.svg`} alt=""/>
              </button>
              }
              {!selected &&
              <button  onClick={() => toggleBank(bankData, "add")} className="ct__button ct__button__summary ct__button__summary--grey ct__button-icon">
                <img src={`${assetsBaseUrl}/assets/svg/add.svg`} alt=""/>
              </button>
              }
            </div>
            }
        </div>
    );
}

export default BankCard;
